import { DBConfig } from 'ngx-indexed-db';

export enum DbStores {
  AVATARS = 'avatars',
}

export const DB_CONFIG: DBConfig = {
  name: 'Cloudia',
  version: 1,
  objectStoresMeta: [
    {
      store: DbStores.AVATARS,
      storeConfig: {
        keyPath: 'authId',
        autoIncrement: false,
      },
      storeSchema: [
        { name: 'data', keypath: 'data', options: { unique: false } },
        {
          name: 'expirationTime',
          keypath: 'expirationTime',
          options: { unique: false },
        },
      ],
    },
  ],
};
